var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewardSmelt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5203 0L14.3107 1.57369L4.31414 6.66391L6.49503 7.93501L16.6405 2.64496L23 6.02846V7.41451L11.5203 13.4187L8.76378 11.8268L18.7264 6.71243L16.3696 5.50786L6.40695 10.7979L0 7.37817V6.02846L11.5203 0Z",
    fill: "#AA7D50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07532 18.9871L6.583 20.4156L0 17.1169V8.92773L11.5203 14.9319L23 8.92773V17.0745L11.4999 23L8.8112 21.493L20.02 15.7248V13.4188L11.5203 17.7161L2.9799 13.4188V15.7248L9.07532 18.9871Z",
    fill: "#A6A8AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardSmelt);
export default __webpack_public_path__ + "static/media/reward_smelt.4a0a0fd030eb2456f5d4b693fd664999.svg";
export { ForwardRef as ReactComponent };